var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "12px",
    viewBox: "0 0 21 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/sort",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.44156697,-3.79252185e-13 L4.441,8.468 L7.06390962,8.46804519 L3.53195481,12 L6.63078925e-10,8.46804519 L2.693,8.468 L2.69333853,-3.79252185e-13 L4.44156697,-3.79252185e-13 Z M12.7408887,9.98987679 L12.7408887,11.9878522 L8.99088869,11.9878522 L8.99088869,9.98987679 L12.7408887,9.98987679 Z M16.4908887,4.9949384 L16.4908887,6.99291376 L8.99088869,6.99291376 L8.99088869,4.9949384 L16.4908887,4.9949384 Z M20.2408887,2.92021518e-10 L20.2408887,1.99797536 L8.99088869,1.99797536 L8.99088869,2.92021518e-10 L20.2408887,2.92021518e-10 Z",
    id: "sort",
    fill: "#666666",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.92d6da2ef976694f48f2b33909e3e2c9.svg";
export { ForwardRef as ReactComponent };